import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DatatableRootObject, DataTablesResponse, OtpValidated, PagedList, User, UserRegistration, UserToken } from '../interfaces/interfaces.index';
import { OtpVerify, Petition } from 'src/app/interfaces/interfaces.index';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SocialUser } from 'angularx-social-login';
import { Router } from '@angular/router';
const URL = `${URL_SERVICIOS}user`;
const URLAUTH = `${URL_SERVICIOS}auth`;
const URLOTP = `${URL_SERVICIOS}External`;


@Injectable({
  providedIn: 'root'
})

export class UserService {

  helper = new JwtHelperService();
  user: User;
  userToken: UserToken;
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private previousUrl = '';
  private currentUrl = '';
  public listDocumentCorrection = sessionStorage.getItem('documentsListCorrection');
  public documentVersion = sessionStorage.getItem('documentsVersion');
  keyChangePass: string;
  public currentPetitionUserId: number;
  public currentPetitionPersonType: string;
  public currentPetitionTypeAdjudged: string;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('userToken')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.cargarStorage();
  }

  Savesresponse = (responce: SocialUser) => this.http.post<UserToken>(`${URLAUTH}/SocialMedia`, responce);

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  estaLogueado = () => (this.userToken.token.length > 5) ? true : false;

  cargarStorage() {
    if (sessionStorage.getItem('userToken')) {
      this.userToken = JSON.parse(sessionStorage.getItem('userToken'));
      this.user = JSON.parse(this.getUser(this.userToken).user);
    } else {
      this.userToken = null;
      this.user = null;
    }
  }

  login = (login) => this.http.post<UserToken>(`${URLAUTH}`, JSON.stringify(login), HTTP_OPTIONS)
    .pipe(map(user => this.processLogin(user)))

  processLogin(user: UserToken) {
    if (user.token) {

      this.currentUserSubject.next(this.getUser(user));
      sessionStorage.setItem('userToken', JSON.stringify(user));
      this.cargarStorage();
    }
    return user;
  }

  getUser = (user: UserToken) => this.helper.decodeToken(user.token);

  logout() {
    if(sessionStorage.getItem('UserId')){
      sessionStorage.removeItem('UserId');
    }

    if(sessionStorage.getItem('Adviser')) sessionStorage.removeItem('Adviser');

    sessionStorage.removeItem('userToken');
    if (sessionStorage.getItem('capacidadPago')){
      sessionStorage.removeItem('capacidadPago');
    }
    sessionStorage.removeItem('selPetition');

    if (sessionStorage.getItem('errores')) {
      sessionStorage.removeItem('errores');
    }

    this.user = null;
    this.userToken = null;
    this.currentUserSubject.next(null);
  }

  revokeToken = () => this.http.post(`${URLAUTH}/revokeToken`, JSON.stringify({ refreshToken: this.userToken.refreshToken }), HTTP_OPTIONS);

  refreshToken = () => this.http.post<UserToken>
    (`${URLAUTH}/refreshToken`, JSON.stringify({ refreshToken: this.userToken.refreshToken }), HTTP_OPTIONS)
    .pipe(map(res => this.processLogin(res)))

  getAllUsers = () => this.http.get<PagedList<User>>(URL, HTTP_OPTIONS);

  getUsersDataTable = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<User>>(`${URL}/datatable`, tableObj, HTTP_OPTIONS);

  completeRegistration = (id: number, password: string) => this.http.put(`${URL}/${id}`, { password }, HTTP_OPTIONS);

  changePasswordprofile = (id: number, password: string) => this.http.put(`${URL}/changepasswordprofile/${id}`, { password }, HTTP_OPTIONS);

  createOtp = (petitionId: number, comunicationNumber: string) =>
    this.http.get<string>(`${URL}/otpCreate/${petitionId}?comunicationNumber=${comunicationNumber}`, HTTP_OPTIONS)

  ValidateOtp = (codigo: OtpVerify) => this.http.post<OtpValidated>(`${URLOTP}/validateOtp`, JSON.stringify(codigo), HTTP_OPTIONS);

  sendCodePost = (codigo: any) => this.http.post(`${URLOTP}/requestRotuine`, JSON.stringify(codigo), HTTP_OPTIONS );

  setearStore = (petition: Petition) => sessionStorage.setItem('selPetition', JSON.stringify(petition));

  changePasswordProcess = (email) =>
    this.http.get(`${URL}/changePasswordProcess/${email}`, HTTP_OPTIONS);

  changePassword = (password: any) =>
    this.http.post(`${URL}/changePassword`, password, HTTP_OPTIONS);

  authControlDocument = () => {
    if (
      (this.listDocumentCorrection) &&
      (this.documentVersion)
    ) {
      sessionStorage.removeItem('documentsListCorrection');
      sessionStorage.removeItem('documentsVersion');
    }
  };

  checkAdjudgedAndTerms = (email: string) => this.http.get(`${URLAUTH}/checkAdjudgedAndTerms/${email}`, HTTP_OPTIONS);

  getListRoles = () => this.http.get<any>(`${URL}/GetListRoles`);

  createUser = (user: UserRegistration) => this.http.post<any>(URL, user, HTTP_OPTIONS);

  getUserById = (id: string) => this.http.get(`${URL}/${id}`, HTTP_OPTIONS);

  putUserById = (id: string, user: UserRegistration) => this.http.put(`${URL}/${id}`, user, HTTP_OPTIONS);

  deleteUserById = (id: string) => this.http.delete(`${URL}/${id}`, HTTP_OPTIONS);

  getAllUserAdmAsync = () => this.http.get<User[]>(`${URL}/GetAllUserAdmAsync`, HTTP_OPTIONS);
}
